import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  styled,
  Box,
  keyframes,
} from "@mui/material";

// Styled component using MUI v5's styled API
const NavbarTitle = Typography;

// Define the keyframes animation
const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const Navbar = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        {/* Left side: Logo + Title */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Box
            component="img"
            src="/images/logo-no-bg.png" // Replace with your actual logo path
            alt="Logo"
            sx={{
              height: 40,
              marginRight: 1,
              animation: `${pulseAnimation} 2s infinite ease-in-out`,
            }}
          />
          <NavbarTitle variant="h6" component="div">
            Perfect Hair Threading Salon
          </NavbarTitle>
        </Box>

        <Button color="inherit" href="/">
          Home
        </Button>
        <Button color="inherit" href="/book-appointment">
          Book
        </Button>
        <Button color="inherit" href="/dashboard">
          Admin
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
